import useCopyToClipboard from 'react-use/lib/useCopyToClipboard';
import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { Typography, Next, Button, ButtonVariant, Icon, IconSize } from '@shipengine/giger';
import useSendMetrics from '../../../hooks/useSendMetrics.js';
import { TrackingDetailsMetricsEvent } from '../../../types.js';
import { getParcelTrackingNumberWrapperStyles, getParcelTrackingNumberLinkStyles, getParcelTrackingNumberButtonStyles } from './ParcelTrackingNumberStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { getTrackingUrl } from '../../../utils/TrackingUrl.js';

function ParcelTrackingNumber(_ref) {
  let {
    trackingNumber,
    trackingUrl,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation();
  const [, copyToClipboard] = useCopyToClipboard();
  const onCopy = () => copyToClipboard(trackingNumber);
  const sendEvent = useSendMetrics();
  return jsxs("div", {
    ...otherProps,
    children: [jsx(Typography, {
      variant: "subtitle2",
      bold: true,
      component: "div",
      children: t('tracking-details.titles.tracking-number')
    }), jsxs("span", {
      css: getParcelTrackingNumberWrapperStyles,
      children: [trackingUrl ? jsx(Next.Link, {
        css: getParcelTrackingNumberLinkStyles,
        href: getTrackingUrl(trackingUrl, trackingNumber),
        target: "_blank",
        onClick: () => sendEvent(TrackingDetailsMetricsEvent.OnClickTrackingNumber),
        children: trackingNumber
      }) : jsx(Typography, {
        variant: "small",
        component: "div",
        children: trackingNumber
      }), jsx(Button, {
        variant: ButtonVariant.TEXT,
        css: getParcelTrackingNumberButtonStyles,
        onClick: onCopy,
        children: jsx(Icon, {
          name: IconNames.COPY,
          size: IconSize.SIZE_MEDIUM
        })
      })]
    })]
  });
}

export { ParcelTrackingNumber };
//# sourceMappingURL=ParcelTrackingNumber.js.map
